import React, { useEffect, useState } from 'react'
import Svg from '../../../common/Svg'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getSurveyFormData, getSurveySectionData, submitResponseData, submitSurveyData, getSurveyDetail } from '../../../store/actions/surveyFormAction'
import { getRequiredText } from '../../../utils/validationTranslations'
import CustomInput from './CustomInput'
import { useFormik } from 'formik';
import * as Yup from 'yup';

const SinglePageSurvey = () => {
    //==> States <==
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { survey_id, ss_id } = useParams();
    const { surveyFormQuestions, surveySections } = useSelector((state) => state.surveyData)
    const surveyDetail = useSelector((state) => state.surveyData?.surveyDetail)
    const surveyLangName = surveyDetail?.length > 0 ? surveyDetail[0]?.language_name?.toLowerCase() : "english";

    const [sectionWiseQuestion, setSectionWiseQuestion] = useState({})
    const [lastRespondedQuestion, setLastRespondedQuestion] = useState('')
    let numbering = 0



    //Yup - Schema
    const requiredText = getRequiredText(surveyLangName);
    let schemaShape = {}

    surveyFormQuestions?.forEach((que) => {
        const isRequired = que.su_is_required === 1
        const key = que.su_question_id

        if (isRequired) {
            schemaShape[key] = Yup.string().required(requiredText)
        } else {
            schemaShape[key] = Yup.string()
        }
    })

    //Formik
    let initialValues = {}
    let initialTouched = {}
    let initialError = {}
    surveyFormQuestions?.forEach((question) => {
        const key = question.su_question_id
        initialValues[key] = ""
        initialTouched[key] = false
        initialError[key] = ''
    })

    const Schema = Yup.object().shape(schemaShape);
    const formik = useFormik({
        initialValues: initialValues,
        initialTouched: initialTouched,
        initialErrors: initialError,
        validationSchema: Schema,
        onSubmit: (values) => {
            const { responseNo, serialNo } = genSerialAndResponse(values, -1, -1)
            const payload = {
                response: responseNo,
                serial_no: serialNo,
                current_question: lastRespondedQuestion,
                survey_id: survey_id,
                ss_id: ss_id
            }
            dispatch(submitSurveyData(payload, navigate))
        }
    })

    //Functionalities
    const getSectionClass = (values, questions, current, key) => {
        const progressClass = 'in-progress'
        if (!key) {
            let isFirstComplete = false
            questions[current]?.forEach((question) => {
                if (values[question.su_question_id]) {
                    isFirstComplete = true
                }
            })
            return isFirstComplete ? progressClass : ''
        }

        let isComplete = true
        questions[key]?.forEach((question) => {
            if (!values[question.su_question_id]) {
                isComplete = false
            }
        })

        if (isComplete) {
            return progressClass
        }
        return ''
    }

    const calculateWidth = (secWiseQues, section, values, length) => {
        if (!secWiseQues && !secWiseQues[section])
            return 0

        const totalQuestion = secWiseQues[section]?.length
        let fieledQuestions = 0

        secWiseQues[section].forEach((question, index) => {
            if (values[question.su_question_id])
                fieledQuestions++
        })

        if (fieledQuestions === 0 || totalQuestion === 0) {
            return 0
        }

        const width = ((fieledQuestions / totalQuestion) * (100 / (length - 1)))
        return width
    }

    const genSerialAndResponse = (values, questionId, questionValue) => {
        let serialNo = ''
        let responseNo = ''
        Object.keys(sectionWiseQuestion).forEach((key) => {
            return sectionWiseQuestion[key].forEach((question) => {
                serialNo += `${question.su_question_id}#`
                if (question.su_question_id === questionId) {
                    responseNo += `${questionValue ?? ''}#`
                } else {
                    responseNo += `${values[question.su_question_id] ?? ''}#`
                }
            })
        })

        return { responseNo, serialNo }
    }

    const scrollToNextQue = (currentQue) => {
        const scrollByHeight = document.getElementById(`qusDiv_${currentQue}`).offsetHeight
        let currentScroll = 0
        const scrolling = setInterval(() => {
            window.scrollBy(0, 10)
            currentScroll += 10
            if (currentScroll >= scrollByHeight) {
                clearInterval(scrolling)
            }
        }, 5)
    }

    //API - Functionalities
    const submitResponse = (questionId, questionValue) => {
        scrollToNextQue(questionId)
        const { responseNo, serialNo } = genSerialAndResponse(formik.values, questionId, questionValue)
        const payload = {
            response: responseNo,
            serial_no: serialNo,
            current_question: questionId,
            ss_id: ss_id
        }
        setLastRespondedQuestion(questionId)
        dispatch(submitResponseData(payload))
    }

    //Effects
    useEffect(() => {
        let token = localStorage.getItem("customer_token")
        if (!token || !ss_id || ss_id === 'undefined' || !survey_id) {
            navigate('/')
        }
        dispatch(getSurveySectionData({
            "survey_id": survey_id
        }))
        dispatch(getSurveyFormData({
            "survey_id": survey_id
        }))
        dispatch(getSurveyDetail({ "survey_id": survey_id }))
    }, [ss_id, survey_id])

    useEffect(() => {
        let data = {}
        surveyFormQuestions?.forEach((question) => {
            const sectionId = question.su_section_id
            if (!data[sectionId]) {
                data[sectionId] = []
            }
            data[sectionId].push(question)
        })

        let tmpData = {}
        Object.keys(data ?? {})?.forEach((section) => {
            const questions = data[section]
            const sortedQuestions = questions.sort((a, b) => Number(a.su_order_no ?? 0) - Number(b.su_order_no ?? 0))
            tmpData[section] = sortedQuestions
        })

        setSectionWiseQuestion(tmpData);
    }, [surveyFormQuestions])


    return (
        <>
            <div className='banner-section-qna bg-img new-banner'>
                <div className="container">
                    <div className="row">
                        <div className='col-lg-8 d-flex align-items-center'>
                            <div className="left-logo">
                                <Svg name="vodafone-logo-small" />
                            </div>
                            <div className="text-wrap flex-grow-1">
                                {/* <div className="logo-wrap">
                                    <Svg name="vodafone-logo" />
                                </div> */}
                                {/* <p><strong>Vodafone</strong> Business</p> */}
                                <h1>Vodafone Business<br /> Rapid Cloud Assessment</h1>
                            </div>
                        </div>
                        {/* <div className='col-md-4 col-lg-5 image-cen'>
                            <div className="img-wrap">
                                <img src={bannerImg} alt='bannerImg' className='img-fluid' />
                            </div>
                        </div> */}
                    </div>

                </div>
            </div>
            <div className="qna-section-wrap">
                <div className="qna-progress">
                    <div className="container">
                        <div className="prograss-wrap ">
                            <div className="prograss-bg">
                                {
                                    Object.keys(sectionWiseQuestion)?.map((key, index, arr) => {
                                        if (index === 0)
                                            return ''

                                        return (
                                            <div
                                                className="prograss-active group-1"
                                                style={{ width: `${calculateWidth(sectionWiseQuestion, key, formik.values, arr?.length)}%` }}
                                                key={index}
                                            />
                                        )
                                    })
                                }
                                {/* <div className="prograss-active group-1" style={{ width: '20%' }} />
                                <div className="prograss-active group-1" style={{ width: '0%' }} />
                                <div className="prograss-active group-1" style={{ width: '0%' }} />
                                <div className="prograss-active group-1" style={{ width: '0%' }} />
                                <div className="prograss-active group-1" style={{ width: '0%' }} /> */}
                                {/* <div className="prograss-active group-1" style={{ width: `${calculateWidth(formik.values)}` }} /> */}
                            </div>
                            <div className="prograss-listing">
                                <ul>
                                    {
                                        Object.keys(sectionWiseQuestion)?.map((key, index, arr) => {
                                            return (
                                                <li className={`${getSectionClass(formik.values, sectionWiseQuestion, key, arr[index])} group-${index}`} key={index}>
                                                    <div className="text-wrap">{surveySections[key]?.name}</div>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="questions-wrapper">
                    <div className="container">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="question-list">
                                {
                                    Object.keys(sectionWiseQuestion).map((key) => {
                                        return sectionWiseQuestion[key].map((question, index) => {
                                            numbering++
                                            return (<div key={index} id={`qusDiv_${question.su_question_id}`}>
                                                <CustomInput
                                                    fieldData={question}
                                                    formikData={formik}
                                                    submitResponseCallback={submitResponse}
                                                    numbering={numbering}
                                                />
                                            </div>)
                                        })
                                    })
                                }

                            </div>
                            <div className="btn-wrapper text-center">
                                <button className='btn btn-primary btn-icon mx-auto' type='submit'>
                                    Get your personalized recommendation <Svg name="button-icon" />
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SinglePageSurvey